import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import styled from 'styled-components';

export const StyledDragAndDrop = styled((props: UploadProps) => <Upload.Dragger {...props} />)`
    .ant-upload-drag {
        background: #fff;
    }
`;
